<!--component html goes here -->
<!--component html goes here -->
<page-load-header *ngIf="!initialized"></page-load-header>
<ng-container *ngIf="initialized">
  <div #fullscreenContainer>
    <header>
      <!-- Fixed navbar -->
      <nav class="navbar nowrap navbar-expand-md navbar-light bg-white">
        <a class="navbar-brand event-title text-truncate cursor-pointer">{{ course.title }} - {{ course.instructor.fullNameWithCredentials }}</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <!-- <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Link</a>
          </li>
          <li class="nav-item">
            <a class="nav-link disabled" href="#">Disabled</a>
          </li>
        </ul> -->
          <div class="form-inline ml-auto mt-2 mt-md-0">
            <button type="button" (click)="fullscreen()" class="btn btn-icon text-muted transition-3d-hover">
              <h3><span class="fas fa-compress-wide btn-icon__inner"></span></h3>
            </button>

            <button type="button" class="btn btn-icon" (click)="exitPage()">
              <h3 class="m-0 text-muted"><i class="fas fa-times"></i></h3>
            </button>
          </div>
        </div>
      </nav>
    </header>

    <main id="live-event" class="main-container">
      <div class="main-theater">
        <div class="row no-gutters">
          <div class="col text-center video-container">
            <div *ngIf="!availible && course.encoded && course.userHasPurchased" class="alert alert-danger">This course is unavailable at this time. Please check back later.</div>
            <div *ngIf="!availible && !course.encoded && course.userHasPurchased" class="alert alert-danger">This course is still processing. Please check back later.</div>
            <div *ngIf="!availible && !course.userHasPurchased" class="alert alert-danger">You have not purhased this course.</div>
            <div *ngIf="availible" #wowzaPlayer id="wowzaPlayer" class="azuremediaplayer amp-default-skin embed-responsive live-player live-player-fluid hide-fullscreen"  style="z-index: 0; background-color: black; display:flex; align-items: center">
            </div>
<!--            <video *ngIf="availible" #livePLayer id="livePLayer" class="azuremediaplayer amp-default-skin embed-responsive live-player live-player-fluid" style="z-index: 0" poster="../../assets/off-air.png" autoplay></video>-->
          </div>
          <footer class="live-footer">
            <div class="row no-gutters">
              <div class="col pl-2 pr-2">
                <div class="d-flex">
                  <div class="mr-auto">
                    <div class="align-middle">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item mr-2 font-size-1" data-toggle="tooltip" data-placement="top" title="" data-original-title="Tech Support">
                          <p class="text-primary"><a class="cursor-pointer" (click)="techSupportClicked()">Help</a></p>
                        </li>

                      </ul>
                    </div>
                  </div>

                  <div *ngIf="availible" class="">
                    <div class="align-middle">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item mr-3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Access CEU tokens and generate certificates">
                          <p class="text-primary"><a [ngClass]="{ 'live-event-link-active': showMaterials }" class="cursor-pointer" (click)="showMaterials = !showMaterials; showAssessment = false">Materials</a></p>
                        </li>
                        <li *ngIf="(course.ceus | ceuCount) > 0" class="list-inline-item mr-3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Access CEU tokens and generate certificates">
                          <p class="text-primary"><a [ngClass]="{ 'live-event-link-active': showAssessment }" class="cursor-pointer" (click)="CEUClicked(); showMaterials = false">CEUs</a></p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <ng-container *ngIf="availible">
            <div class="popover-window col" [ngClass]="{ 'd-none': !showMaterials }">
              <bxl-course-materials [course]="course" (closed)="showMaterials = false"></bxl-course-materials>
            </div>
          </ng-container>
        </div>
      </div>
    </main>
  </div>
</ng-container>
